var map = {
	"./Checkpoint1.png": 7003,
	"./Checkpoint10.png": 8054,
	"./Checkpoint11.png": 9864,
	"./Checkpoint12.png": 7478,
	"./Checkpoint13.png": 6996,
	"./Checkpoint14.png": 8575,
	"./Checkpoint15.png": 644,
	"./Checkpoint16.png": 7123,
	"./Checkpoint17.png": 7342,
	"./Checkpoint18.png": 7080,
	"./Checkpoint19.png": 2690,
	"./Checkpoint2.png": 4570,
	"./Checkpoint20.png": 2208,
	"./Checkpoint3.png": 6122,
	"./Checkpoint4.png": 9078,
	"./Checkpoint5.png": 7871,
	"./Checkpoint6.png": 2614,
	"./Checkpoint7.png": 23,
	"./Checkpoint8.png": 4997,
	"./Checkpoint9.png": 1236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;